// Conta GAM selecionada no painel.
//
// Fica fora do React de propósito: as funções de API (getDomains, relatórios,
// custom targeting) leem daqui para mandar `network` sem que cada uma das ~20
// telas precise receber e repassar a conta. O NetworkContext é quem escreve.
//
// Plano em api-rocketads/DOCS/contexto/gam-segunda-conta.md.

export interface GamNetwork {
    network_code: string;
    name: string;
    is_default: boolean;
    label: string; // "Nome - ID", montado pela API
}

const STORAGE_KEY = 'gam_network';

// Filtros de domínio salvos pelas telas de relatório. São da conta que estava
// selecionada: depois de trocar, apontariam para domínios da outra conta.
export const FILTROS_DE_DOMINIO_SALVOS = ['dashboard_domains', 'reports_domains', 'kv_domains'];

let selecionada: string | null = lerSalva();

function lerSalva(): string | null {
    try {
        return localStorage.getItem(STORAGE_KEY);
    } catch {
        return null;
    }
}

export function getSelectedNetwork(): string | null {
    return selecionada;
}

export function setSelectedNetwork(networkCode: string | null): void {
    selecionada = networkCode;
    try {
        if (networkCode) localStorage.setItem(STORAGE_KEY, networkCode);
        else localStorage.removeItem(STORAGE_KEY);
    } catch {
        // Sem storage (aba privada): vale só para esta aba.
    }
}

export function limparFiltrosDeDominio(): void {
    for (const chave of FILTROS_DE_DOMINIO_SALVOS) {
        try {
            localStorage.removeItem(chave);
        } catch {
            // idem
        }
    }
}

// Escolhe a conta a usar: a salva, se ainda existir na lista; senão a padrão.
export function resolverSelecao(networks: GamNetwork[], salva: string | null): string | null {
    if (salva && networks.some((n) => n.network_code === salva)) return salva;
    return networks.find((n) => n.is_default)?.network_code ?? networks[0]?.network_code ?? null;
}

// "Nome - ID" para um network_code qualquer. Conta que não está na lista
// (hoje só a do creditfinder) aparece como "ID - fora da lista" — nunca o
// número solto, nunca só o nome.
export function formatNetwork(networkCode: string | null | undefined, networks: GamNetwork[]): string {
    if (!networkCode) return '—';
    const conta = networks.find((n) => n.network_code === String(networkCode));
    return conta ? conta.label : `${networkCode} - fora da lista`;
}
